module.exports = __webpack_public_path__ + "img/image_ornaments_b.69307d1a.png";